import { useState, useEffect } from 'react';
import { usePostTripConnect } from '../../../../context/postTripConnect/PostTripConnectContext';
import EnquiriesTable from './sections/EnquiriesTable/EnquiriesTable';
import EnquiryModal from './sections/EnquiryModal/EnquiryModal';

const EnquiriesTab = () => {
    const {
        enquiries,
        enquiriesLoading: loading,
        fetchEnquiries,
        deleteEnquiry,
        updateEnquiryStatus,
        exportEnquiriesCSV
    } = usePostTripConnect();
    const [statusFilter, setStatusFilter] = useState('');
    const [selectedEnquiry, setSelectedEnquiry] = useState(null);

    useEffect(() => {
        fetchEnquiries({ status: statusFilter || undefined });
    }, [statusFilter, fetchEnquiries]);

    const handleDelete = async (id) => {
        if (!window.confirm('Are you sure you want to delete this enquiry?')) return;
        try {
            await deleteEnquiry(id);
            if (selectedEnquiry && selectedEnquiry._id === id) {
                setSelectedEnquiry(null);
            }
        } catch (error) {
            console.error('Failed to delete enquiry:', error);
        }
    };

    const handleUpdateStatus = async (id, newStatus) => {
        try {
            await updateEnquiryStatus(id, newStatus);
            if (selectedEnquiry) {
                setSelectedEnquiry(prev => prev ? { ...prev, status: newStatus } : null);
            }
        } catch (error) {
            console.error('Failed to update enquiry status:', error);
        }
    };

    const handleExportCSV = async () => {
        try {
            const blob = await exportEnquiriesCSV({ status: statusFilter || undefined });
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `enquiries_${new Date().toISOString().split('T')[0]}.csv`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Failed to export enquiries:', error);
        }
    };

    return (
        <>
            <EnquiriesTable
                enquiries={enquiries}
                loading={loading}
                statusFilter={statusFilter}
                setStatusFilter={setStatusFilter}
                onExportCSV={handleExportCSV}
                onSelect={(enq) => setSelectedEnquiry(enq)}
                onDelete={handleDelete}
                onStatusChange={handleUpdateStatus}
            />

            {selectedEnquiry && (
                <EnquiryModal
                    enquiry={selectedEnquiry}
                    onClose={() => setSelectedEnquiry(null)}
                    onUpdateStatus={handleUpdateStatus}
                />
            )}
        </>
    );
};

export default EnquiriesTab;
